const allPermissions = () => {
  return [
    'project_created',
    'quotation',
    'status',
    'quotation_file',
    'add_scope',
    'pause_project',
    'delivery_date',
    'payments',
    'add_shipment',
    'update_shipment',
    'update_claim',
    'revision_approved',
    'reply_date',
    'add_rfi',
    'update_rfi'
  ]
}

export default allPermissions
